import React from 'react';
import {OdontoSelectedDateProfessionalListProps} from './types';
import {useOdontoSelectedDateProfessionalList} from './hooks/useOdontoSelectedDateProfessionalList';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {OdontoProfessionalSelectionNotFoundState} from '../OdontoProfessionalSelectionNotFoundState';
import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {ProfessionalDateList} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateList';
import {ProfessionalDateSection} from 'presentation/modules/booking/shared/ui/components/ProfessionalSelection/ProfessionalDateSection';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {bookOdonto} = translations['pt-br'].privateFlow.services;
const {loadingState, loadingError} = translations['pt-br'].privateFlow.bookingFlow.professionalFlow;

export function OdontoSelectedDateProfessionalList({
	handleSelectHour,
	handleClearShiftAndSearch,
}: OdontoSelectedDateProfessionalListProps) {
	const {
		isLoading,
		isError,
		showNotFoundState,
		selectedDate,
		odontoAvailableTimesFiltered,
		query,
		odontoAvailableTimesRefetch,
	} = useOdontoSelectedDateProfessionalList();

	if (isLoading) {
		return (
			<BookingLoadingState
				showHeader={false}
				pageTitle={bookOdonto}
				loadingText={loadingState}
			/>
		);
	}

	if (isError) {
		return (
			<BookingErrorState
				showHeader={false}
				pageTitle={bookOdonto}
				errorTitle={loadingError}
				handleRefresh={odontoAvailableTimesRefetch}
			/>
		);
	}

	if (showNotFoundState) {
		return (
			<OdontoProfessionalSelectionNotFoundState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_PROFISSIONAL_DISPONIVEL}
				showClearFilterButton
				handleClearShiftAndSearch={() => {
					handleClearShiftAndSearch();
				}}
			/>
		);
	}

	return (
		<ProfessionalDateList>
			<ProfessionalDateSection
				date={selectedDate}
				professionals={odontoAvailableTimesFiltered ?? []}
				onSelectHour={handleSelectHour}
				flowType={FlowEnum.ODONTO}
				query={query}
			/>
		</ProfessionalDateList>
	);
}
